import JSZip from "jszip";
import FtpService from "../../../../../services/ftp.service";
import {getFileNameFromPath, getUniqueFilename} from "../helperFunctions";

/**
 * Helper function to export the attachments in a merged pdf
 * @param attachments names of the attachments
 * @param name name of the group or the participant
 * @param planDate date of the plan
 * @author KMU
 */
export async function exportAttachments(attachments: string[], name: string, planDate: string) {
    const zip = new JSZip();
    const formattedDate = new Date(planDate)
        .toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: 'numeric'})
        .replace(/\./g, '_');
    const folderName = "Anhaenge_" + name + "_" + formattedDate + ".zip";

    const usedNames = new Set<string>();
    const counts = new Map<string, number>();

    // merge all pdfs together into one file
    const pdfs = attachments.filter(a => a.toLowerCase().endsWith(".pdf"));
    const mergedPdf = await FtpService.getMergedPDFFile(pdfs);

    if (mergedPdf.data.size > 0) {
        const mergedFilename = getUniqueFilename("Anhaenge.pdf", usedNames, counts);
        zip.file(mergedFilename, await mergedPdf.data.arrayBuffer());
        usedNames.add(mergedFilename);
    }

    // add all other files without merging
    const otherFiles = attachments.filter(a => !a.toLowerCase().endsWith(".pdf"));
    for (let i = 0; i < otherFiles.length; i++) {
        const path = otherFiles[i];
        const filename = getFileNameFromPath(path);

        if (path === "" || filename === "") {
            continue; //Skip empty paths
        }

        const uniqueFilename = getUniqueFilename(filename, usedNames, counts);
        usedNames.add(uniqueFilename);

        const response = await FtpService.getFile(path);
        const fileBuffer = await response.data.arrayBuffer();

        zip.file(uniqueFilename, fileBuffer);
    }

    //create zip
    const content = await zip.generateAsync({type: "blob"});

    //automatically download the zip without user interaction
    const url = URL.createObjectURL(content);
    const a = document.createElement("a");

    a.href = url;
    a.download = folderName;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url); //Free up memory
}